module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_library.js
// module id = 179
// module chunks = 2